<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" class="inner-content">
    <mat-list>
        <mat-list-item *ngFor="let document of documents">
            <button 
            mat-icon-button 
            (click)="goToUrl(document.url)"
            matTooltip="Navigate to {{ document.title }}">
                <mat-icon>open_in_new</mat-icon>
            </button>
            <div mat-line><strong> {{ document.title }} </strong></div>
            <div mat-line> {{ document.url }} </div>
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
</div>

